// React
import { useContext } from 'react';

// Custom components
import ActiveSubmissionLog from './ActiveSubmissionLog';

// Styled
import { Wrapper } from './styled';

// Context
import { SubmissionContext } from 'pages/TemplateDashboard/Tabs/Submissions/context';

const SubmissionTemplatePreview = () => {
  const ctx = useContext(SubmissionContext);

  return ctx?.activeSubmission ? (
    <Wrapper>
      <ActiveSubmissionLog
        activeSubmission={ctx.activeSubmission}
        template={ctx?.template}
        handleArchiveLogs={ctx?.handleArchiveLogs}
      />
    </Wrapper>
  ) : (
    <></>
  );
};

export default SubmissionTemplatePreview;
